import { IsSsrMobileContext } from "@/Context/IsSsrMobile";
import { useContext } from "react";
import { useMediaQuery } from "react-responsive";

export const useIsTablet = () => {
  const { device } = useContext(IsSsrMobileContext);
  const isTablet = useMediaQuery({ query: '(max-width: 991.98px)' });

  return (device === 'mobile') && isTablet;
};
